export const iLayerZeroEndpointAbi = [
  {
    type: 'function',
    inputs: [
      { name: '_dstChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_userApplication', internalType: 'address', type: 'address' },
      { name: '_payload', internalType: 'bytes', type: 'bytes' },
      { name: '_payInZRO', internalType: 'bool', type: 'bool' },
      { name: '_adapterParam', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'estimateFees',
    outputs: [
      { name: 'nativeFee', internalType: 'uint256', type: 'uint256' },
      { name: 'zroFee', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_srcChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_srcAddress', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'forceResumeReceive',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getChainId',
    outputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_version', internalType: 'uint16', type: 'uint16' },
      { name: '_chainId', internalType: 'uint16', type: 'uint16' },
      { name: '_userApplication', internalType: 'address', type: 'address' },
      { name: '_configType', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getConfig',
    outputs: [{ name: '', internalType: 'bytes', type: 'bytes' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_srcChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_srcAddress', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'getInboundNonce',
    outputs: [{ name: '', internalType: 'uint64', type: 'uint64' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_dstChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_srcAddress', internalType: 'address', type: 'address' },
    ],
    name: 'getOutboundNonce',
    outputs: [{ name: '', internalType: 'uint64', type: 'uint64' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_userApplication', internalType: 'address', type: 'address' }],
    name: 'getReceiveLibraryAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_userApplication', internalType: 'address', type: 'address' }],
    name: 'getReceiveVersion',
    outputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_userApplication', internalType: 'address', type: 'address' }],
    name: 'getSendLibraryAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_userApplication', internalType: 'address', type: 'address' }],
    name: 'getSendVersion',
    outputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_srcChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_srcAddress', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'hasStoredPayload',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isReceivingPayload',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isSendingPayload',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_srcChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_srcAddress', internalType: 'bytes', type: 'bytes' },
      { name: '_dstAddress', internalType: 'address', type: 'address' },
      { name: '_nonce', internalType: 'uint64', type: 'uint64' },
      { name: '_gasLimit', internalType: 'uint256', type: 'uint256' },
      { name: '_payload', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'receivePayload',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_srcChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_srcAddress', internalType: 'bytes', type: 'bytes' },
      { name: '_payload', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'retryPayload',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_dstChainId', internalType: 'uint16', type: 'uint16' },
      { name: '_destination', internalType: 'bytes', type: 'bytes' },
      { name: '_payload', internalType: 'bytes', type: 'bytes' },
      {
        name: '_refundAddress',
        internalType: 'address payable',
        type: 'address',
      },
      { name: '_zroPaymentAddress', internalType: 'address', type: 'address' },
      { name: '_adapterParams', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'send',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_version', internalType: 'uint16', type: 'uint16' },
      { name: '_chainId', internalType: 'uint16', type: 'uint16' },
      { name: '_configType', internalType: 'uint256', type: 'uint256' },
      { name: '_config', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'setConfig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_version', internalType: 'uint16', type: 'uint16' }],
    name: 'setReceiveVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_version', internalType: 'uint16', type: 'uint16' }],
    name: 'setSendVersion',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const
